import { useCallback } from "react";

import { useFlightFiltersContext } from "@/features/flights/contexts/FlightFiltersContext";
import { useFlightSelectionPayloadContext } from "@/features/flights/contexts/FlightSelectionPayloadContext/FlightSelectionPayloadContext";
import type { FlightSearchPagedResultData } from "@/features/flights/hooks/flightSearch/types";
import type { MappedFlightOffer } from "@/features/flights/types/types";

import {
  useFlightQuickSearchTokens,
  useFlightSearchTokens,
} from "../useFlightSearchTokens";

import { useFlightSearch } from "./useFlightsSearch";
import { getOfferByIdFromSearchResult } from "./utils";

export const useSelectedOffer = () => {
  const { selectedOfferIndex, selectedFlightSearchSource } =
    useFlightSelectionPayloadContext();
  const quickTokensQuery = useFlightQuickSearchTokens();
  const { query: tokensQuery } = useFlightSearchTokens({
    enabled: selectedFlightSearchSource === "full",
  });
  const { filters } = useFlightFiltersContext();

  const select = useCallback(
    (response: FlightSearchPagedResultData) =>
      getOfferByIdFromSearchResult(response, selectedOfferIndex),
    [selectedOfferIndex],
  );

  return useFlightSearch<MappedFlightOffer | undefined>(
    selectedFlightSearchSource === "quick" ? quickTokensQuery : tokensQuery,
    filters,
    {
      select,
    },
  );
};
